export default "__VITE_ASSET__BP$aiY6h__"